'use client';

import dynamic from 'next/dynamic';
import { useEffect } from 'react';
// import { ToastContainer } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'

// Load the ToastContainer only on the client
const ToastContainer = dynamic(() => import('react-toastify').then((m) => m.ToastContainer), {
  ssr: false,
  loading: () => null,
});

export default function ToastProvider() {
  useEffect(() => {
    import('react-toastify/dist/ReactToastify.css');
  }, []);

  return (
    <ToastContainer
      stacked
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
}
